export const FEATURE_IS_BETA = false;

export const FEATURE_PLAN = 'business';

export const GATE_FEEDBACK = 'feedback.teams_integration';

export const GATE_ANALYTICS = 'analytics.teams_integration';

export const UPSELL_REFERRER_ANALYTICS = 'analytics_product.integrations_teams';

export const UPSELL_REFERRER_FEEDBACK = 'feedback_product.integrations_teams';

export const PERMISSION_CONNECT = 'site-integrations-status-write';

export const PERMISSION_ENABLE = 'site-integrations-teams-write';
